import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { ChannelState } from '@x/ecommerce-shop/app/channel/state/channel.state';
import { IShopChannelDetail } from '@x/ecommerce/shop-client';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ChannelFetchActive } from '../state/channel.actions';

export const channelResolver: ResolveFn<IShopChannelDetail | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const channelCode = route.params['channelCode'];
  const store = inject(Store);

  return store.dispatch(new ChannelFetchActive(channelCode)).pipe(
    switchMap(() => store.selectOnce(ChannelState.activeChannel)),
    catchError((e) => {
      console.log(
        `%ccant resolve channelCode: ${channelCode}. Showing not found`,
        'color: DodgerBlue',
      );

      return of(null);
    }),
  );
};
